import { Box, Typography } from '@mui/material';

import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

interface ValueCellProps extends BoxProps {
  label: string;
  value?: string;
}

export const ValueCell: FC<ValueCellProps> = ({ label, value, ...props }) => (
  <Box {...props}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    {value && (
      <Typography variant="subtitle1" noWrap>
        {value}
      </Typography>
    )}
  </Box>
);
